import reducer from './reducer'
export * from './actions'
export { default as initialState } from './initialState'
export default reducer
export { default as types } from './types'
